import { withOptionsEndpoint } from "@dgs/core";
import { RegionOptionResource } from "../types/region";

const baseKey = ["regions"];
const quickFilterKey = [...baseKey, "quick-filter"];

export const regionService = {
	...withOptionsEndpoint<RegionOptionResource>(baseKey),
	quickFilterKey,
};
